export default "__VITE_ASSET__DL8sboez__"